import {
    isLiveTv,
    itemHasEnded,
    isRecording,
    isRecordingSeries,
    getCurrentTime
} from 'Utils/index';
import type { PlayerData, StreamType, UnixTimeMs } from 'Types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ITextTrack } from '@24i/player-base';
import { STREAM_TYPE } from '../../../options';

export const shouldSwitchToTimeshift = (
    item: PlayerData['item'],
    streamType?: StreamType,
    offline?: boolean
) =>
    !offline &&
    isLiveTv(item) &&
    // streamType !== STREAM_TYPE.TIMESHIFT &&
    streamType !== STREAM_TYPE.ARCHIVE;

export const shouldReturnBackWhenVideoEnds = (item: PlayerData['item'], streamType: StreamType) =>
    isRecording(item) ||
    isRecordingSeries(item) ||
    streamType === STREAM_TYPE.ARCHIVE ||
    streamType === STREAM_TYPE.VOD;

export const getStreamTypeByItemType = (item: PlayerData['item']): StreamType => {
    if (isLiveTv(item)) {
        return itemHasEnded(item) ? STREAM_TYPE.ARCHIVE : STREAM_TYPE.LIVE;
    }

    return STREAM_TYPE.VOD;
};

export const setMetadataForTimeshift = (metadata, streamData) => {
    const timeshiftMetadata = { ...metadata };
    // Duration is set to now
    const midnight = new Date();
    midnight.setHours(0, 0, 0, 0);
    timeshiftMetadata.duration = (Date.now() - midnight.getTime()) / 1000;
    timeshiftMetadata.offset = streamData.offset;
    timeshiftMetadata.timeshift = streamData.timeshift;

    return timeshiftMetadata;
};

export const filterInvalidTextTracks = (textTracks: ITextTrack[] = []) =>
    textTracks.filter((textTrack) => textTrack.label && !/\d+/.test(textTrack.label));

export const hasAtLeastOneValidTextTrack = (textTracks: ITextTrack[]) =>
    filterInvalidTextTracks(textTracks).length > 0;

export const getStartTime = (item: PlayerData['item'], valueToOffset = 0): UnixTimeMs => {
    const startTimeinMs: UnixTimeMs = 'getStartTime' in item ? item.getStartTime() : 0;
    const startTime = Math.floor(startTimeinMs); // in seconds
    return valueToOffset ? valueToOffset - startTime : startTime;
};

export const getOffsetFromTimestamp = (timestamp: UnixTimeMs) => getCurrentTime() - timestamp;
